import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "SportsFeaturedFiltersWidget" */ './SportsFeaturedFiltersWidget'),
  modules: ['./SportsFeaturedFiltersWidget'],
  loading: () => <div />
});

export default LoadableWidget;
